<template>
  <div id="app">
    <router-view   />
  </div>
</template>
<script>
export default {
  name: "app",
  // data() {
  //   return {
  //     manger:{},
  //   };
  // },
  // created(){
  //     var token= localStorage.getItem("usertoken");
  //     if(token==undefined){
  //       this.isLogin=false;
  //     }else{
  //       this.isLogin=true;
  //       this.manger=JSON.parse(localStorage.getItem("manger"))
  //       console.log(this.manger);
  //       this.menuArr = JSON.parse(this.manger.Power);
  //       console.log(this.menuArr)
  //   }
  // },
};
</script>
